import { useQuery } from "@tanstack/react-query";
import { getScopeOfWork } from "../../jobs/jobs-list/jobs-layout/actions/getScopeOfWork";

export const useGetScopeOfWork = ({ scopeOfWorkUid }: { scopeOfWorkUid?: string }) => {
  const isCreating = window.location.pathname.includes("create");
  const isValidUid = !!scopeOfWorkUid && scopeOfWorkUid !== "undefined" && scopeOfWorkUid !== "null" && scopeOfWorkUid.trim() !== "";

  return useQuery({
    queryKey: ["scopeOfWork", scopeOfWorkUid],
    queryFn: () => getScopeOfWork({ scopeOfWorkUid: scopeOfWorkUid! }),
    enabled: isValidUid && !isCreating,
    retry: false,
    staleTime: 1000 * 60 * 5,
  });
};
